import { render, staticRenderFns } from "./ItemPicker.vue?vue&type=template&id=3632cad6&scoped=true&"
import script from "./ItemPicker.vue?vue&type=script&lang=js&"
export * from "./ItemPicker.vue?vue&type=script&lang=js&"
import style0 from "./ItemPicker.vue?vue&type=style&index=0&id=3632cad6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3632cad6",
  null
  
)

export default component.exports